import { agPriceCol } from '@/ag-grid/ag-columns'
import { formatPrice } from '@lib/formatting.utils'

function editableProperties() {
  return {
    editable: params => {
      return params.data.id !== 'total'
    },
    cellClassRules: { 'editable-cell': params => params.data.id !== 'total' }
  }
}

function filterMaxWidthProperties() {
  return {
    filter: false,
    maxWidth: 500
  }
}

function percentageRenderer() {
  return {
    cellRenderer: params => {
      if (!params.value) return 'N/A'
      return `${formatPrice(params.value)} %`
    }
  }
}

export default {
  computed: {
    gridOptions() {
      if (!this.apiData) return

      const currentYear = this.apiData.column_years.current
      const nextYear = this.apiData.column_years.following

      return {
        columnDefs: [
          {
            headerName: this.departmentLabel.singular.toUpperCase(),
            field: 'name',
            maxWidth: 500,
            cellClassRules: {
              total: params => params.data.id === 'total',
              active: params => params.data.id === this.selectedDepartmentId
            },
            cellClass: params => `dep-id${params.data.id}`
          },

          agPriceCol(`${currentYear} budget`, 'budget', {
            ...filterMaxWidthProperties()
          }),

          agPriceCol(`${nextYear} BUDGET SCENARIO %`, 'following_year_budget_scenario_percentage', {
            ...filterMaxWidthProperties(),
            ...percentageRenderer(),
            editable: params => {
              return params.data.id !== 'total' && params.data.budget !== null
            },
            cellClassRules: {
              'editable-cell': params => params.data.id !== 'total' && params.data.budget !== null
            }
          }),

          agPriceCol(`${nextYear} BUDGET SCENARIO`, 'following_year_budget_scenario_amount', {
            ...filterMaxWidthProperties(),
            ...editableProperties()
          }),

          agPriceCol(`${currentYear} COST`, 'cost', {
            ...filterMaxWidthProperties()
          }),

          agPriceCol(`${nextYear} FORECAST SCENARIO %`, 'following_year_cost_scenario_percentage', {
            ...filterMaxWidthProperties(),
            ...percentageRenderer(),
            editable: params => {
              return params.data.id !== 'total' && params.data.cost !== null
            },
            cellClassRules: {
              'editable-cell': params => params.data.id !== 'total' && params.data.cost !== null
            }
          }),

          agPriceCol(`${nextYear} SCENARIO COST`, 'following_year_cost_scenario_amount', {
            ...filterMaxWidthProperties(),
            ...editableProperties()
          }),

          agPriceCol('DIFFERENCE', 'difference_between_budget_and_cost_scenarios', {
            ...filterMaxWidthProperties(),
            cellRenderer: params => {
              const value = params.value

              if (value === null) return 'N/A'
              if (Number(value) > 0) return `+${this.formatPrice(params.value)} <small>${params.data.currency}</small>`
              return `${this.formatPrice(params.value)} <small>${params.data.currency}</small>`
            }
          })
        ],

        pinnedTopRowData: [this.pinnedRow],

        defaultColDef: {
          floatingFilter: false
        }
      }
    }
  }
}
